import { render, staticRenderFns } from "./GClassManagement.vue?vue&type=template&id=1c79f050&scoped=true&"
import script from "./GClassManagement.vue?vue&type=script&lang=ts&"
export * from "./GClassManagement.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagement.vue?vue&type=style&index=0&id=1c79f050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79f050",
  null
  
)

export default component.exports